export default {
  // 預設公開channel(不須經過broadcast auth)
  CHANNEL_PUBLIC: 'public',
  EVENT_PUBLIC_DEFAULT: 'event-public-default', // 預設event

  // 預設whisper channel(需經過broadcast auth)
  CHANNEL_WHISPER_DEFAULT: 'channel-whisper-default',
  EVENT_WHISPER_DEFAULT_TYPING: 'event-whisper-type', // 輸入文字事件
}